import React from "react";

const AccountReferralCard = ({ account, className = "" }) => {
  const referrer = account?.referred_by;
  const epicJobsId = account?.epic_jobs_id || "Not assigned yet";
  const referrerText = referrer?.epic_jobs_id
    ? `${referrer.name || "Referrer"} (${referrer.epic_jobs_id})`
    : "No referral used";

  return (
    <div className={`account-referral-panel ${className}`.trim()}>
      <div>
        <span>Epic-Jobs ID</span>
        <strong>{epicJobsId}</strong>
      </div>
      <div>
        <span>Referred By</span>
        <strong>{referrerText}</strong>
      </div>
    </div>
  );
};

export default AccountReferralCard;
